import { GlobalService } from 'src/app/shared/services/global/global.service';
import { Component, OnInit, HostListener } from '@angular/core';
import { TranslateService } from "@ngx-translate/core";
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import * as Config from 'src/app/config/app.constant';
import { LANGUAGES } from 'src/app/config/app.constant';
import { AuthService } from 'src/app/core/auth.service';
import { IBreadCrumb } from '../../models/breadcrumb.interface';
import { filter, distinctUntilChanged } from 'rxjs/operators';
import { UserModel } from '../../models/user.model';
import { Subscription } from 'rxjs';
import { LoginService } from 'src/app/modules/login/service/login.service';
import { ExpirePasswordModal } from '../../models/expire-password.model';
import * as moment from 'moment';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit {

  isCollapsed: boolean = false;
  languages: string[] = LANGUAGES;
  currentLang: string;
  languagesTHActive: boolean;
  name: string = '';
  hospital: string = '';
  breadcrumbList: Array<IBreadCrumb> = [];
  user: UserModel;
  userType: string;
  clickedMenu: string = sessionStorage.getItem('select_menu');
  selected1: boolean = (this.clickedMenu === '1' ? true : false);
  selected2: boolean = (this.clickedMenu === '2' ? true : false);
  selected3: boolean = (this.clickedMenu === '3' ? true : false);
  selected4: boolean = (this.clickedMenu === '4' ? true : false);
  selected5: boolean = (this.clickedMenu === '5' ? true : false);  //change password
  selected6: boolean = (this.clickedMenu === '6' ? true : false);
  selected7: boolean = (this.clickedMenu === '7' ? true : false);
  selected8: boolean = (this.clickedMenu === '8' ? true : false);
  textName = 13;

  expPassword: string;
  subscription: Subscription;
  disableExpPass: boolean = false;
  announcePassword: boolean = false;
  expirePassword: boolean = false;
  expireModel: ExpirePasswordModal;
  daysRemaining: number;
  announceModel: ExpirePasswordModal;

  constructor(
    public translate: TranslateService,
    private router: Router,
    private authService: AuthService,
    private activatedRoute: ActivatedRoute,
    private globalService: GlobalService,
    public loginService: LoginService
  ) {
    this.user = JSON.parse(sessionStorage.getItem(Config.USER_DETAIL));
    if (this.user != null) {
      this.userType = this.user.customer.userType;
      this.name = this.user.customer.preName + this.user.customer.firstName + " " + this.user.customer.lastName;
      this.hospital = this.user.customer.hosName;
    };
    this.currentLang = localStorage.getItem(Config.CURRENT_LANGUAGES) ? localStorage.getItem(Config.CURRENT_LANGUAGES) : 'th';
    this.translate.use(this.currentLang);
    this.breadcrumbList = this.buildBreadCrumb(this.activatedRoute.root);
  }

  @HostListener('window:popstate', ['$event'])
  onPopState(event) {
    let currentUrl = window.location.pathname.split('/')
    this.onClickNavigate(currentUrl[2])
  }

  ngOnInit() {
    this.checkCurrentLanguage(this.currentLang);
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      distinctUntilChanged(),
    ).subscribe(() => {
      this.breadcrumbList = this.buildBreadCrumb(this.activatedRoute.root);
    })
    this.widthWindow()
    this.subscription = this.loginService.expPass.subscribe(expPassword => this.expPassword = expPassword);
    /* Expire password to disabled menu */
    if (sessionStorage.getItem('expirePassword')) {
      this.expireModel = JSON.parse(sessionStorage.getItem('expirePassword'));
      console.log("session expire", this.expireModel.title);
      console.log("expPassword ", this.expPassword);

      if (this.expPassword == "expirePassword" || this.expireModel.title == "expirePassword") {
        this.disableExpPass = true;
        if(this.expireModel.expireDate != '00000000' && this.expireModel.flagChange != "N"){
          this.expirePassword = true;
        }
      }
    }

    /* Announce days remaining expire password */
    if (sessionStorage.getItem('announcePassword')) {
      this.announceModel = JSON.parse(sessionStorage.getItem('announcePassword'));
      // this.announceModel.expireDate = '25650122';
      const systemDate = moment(new Date()).add(543, 'year').format("YYYYMMDD");

      var dateExpire = moment(this.announceModel.expireDate);
      var dateSystem = moment(systemDate);
      this.daysRemaining = dateExpire.diff(dateSystem, 'days');
      console.log("dateDiff ", this.daysRemaining);
     
      if (this.announceModel.title == 'announcePassword' && this.daysRemaining <= 7 && this.daysRemaining > 0) {
        this.announcePassword = true;
      }
    }

  }

  closeModalAnnounce(event: any): void {
    this.announcePassword = event.isVisible;
  }

  closeModalExpire(event: any): void {
    this.expirePassword = event.isVisible;
    if(event.value == '2'){
      this.authService.logout();
    }
  }

  screenSize(): boolean {
    if (window.innerWidth <= 1024) {
      this.textName = 24
      return true
    } else {
      this.textName = 13
      return false
    }
  }

  public showAlert(val: string): void {
    alert(val);
  }

  public toggleTranslationLang(val: string): void {
    this.translate.use(val).subscribe(() => {
    });
  }

  checkCurrentLanguage(language: string): void {
    if (language === 'th') {
      this.languagesTHActive = true;
    } else {
      this.languagesTHActive = false;
    }
  }

  changeLanguage(language: string): void {
    this.checkCurrentLanguage(language);
    this.translate.use(language);
    localStorage.setItem(Config.CURRENT_LANGUAGES, language);
  }

  logout(): void {
    this.authService.logout();
  }

  onClickNavigate(actionName: string): void {
    this.clickedMenu = '0'
    this.claerActive();
    if (actionName !== 'check-money-transfers') {
      sessionStorage.removeItem(Config.OLD_RESULT);
    }
    switch (actionName) {
      case 'verification':
        this.router.navigate(["/home/verification"])
        this.clickedMenu = '1'
        sessionStorage.setItem('select_menu', '1');
        this.selected1 = true
        break;
      case 'check-claim-processing':
        this.router.navigate(["/home/check-claim-processing"])
        this.clickedMenu = '2'
        sessionStorage.setItem('select_menu', '2');
        this.selected2 = true
        break;
      case 'check-money-transfers':
        this.router.navigate(["/home/check-money-transfers"]);
        this.clickedMenu = '3'
        sessionStorage.setItem('select_menu', '3');
        this.selected3 = true
        break;
      case 'ดาวน์โหลด':
        this.router.navigate(["/home/download"])
        this.clickedMenu = '4'
        sessionStorage.setItem('select_menu', '4');
        this.selected4 = true
        break;
      case 'change-password':
        this.router.navigate(["/home/change-password"])
        this.clickedMenu = '5'
        sessionStorage.setItem('select_menu', '5');
        this.selected5 = true
        break;
      case 'แสดงความคิดเห็น':
        this.router.navigate(["/home/feedback"])
        this.clickedMenu = '6'
        sessionStorage.setItem('select_menu', '6');
        this.selected6 = true
        break;
      case 'contact-us':
        this.router.navigate(["/home/contact-us"])
        this.clickedMenu = '7'
        sessionStorage.setItem('select_menu', '7');
        this.selected7 = true
        break;
      case 'concurrent-report':
        this.router.navigate(["/home/concurrent-report"])
        this.clickedMenu = '8'
        sessionStorage.setItem('select_menu', '8');
        this.selected8 = true
        break;
      default:
        sessionStorage.removeItem('select_menu');
        this.router.navigate(["/home"])
    }
  }

  claerActive(): void {
    this.selected1 = false;
    this.selected2 = false;
    this.selected3 = false;
    this.selected4 = false;
    this.selected5 = false;
    this.selected6 = false;
    this.selected7 = false;
    this.selected8 = false;
  }


  buildBreadCrumb(route: ActivatedRoute, url: string = '', breadcrumbs: IBreadCrumb[] = []): IBreadCrumb[] {
    let label = route.routeConfig && route.routeConfig.data ? route.routeConfig.data.breadcrumb : '';
    let path = route.routeConfig && route.routeConfig.data ? route.routeConfig.path : '';
    const lastRoutePart = path.split('/').pop();
    const isDynamicRoute = lastRoutePart.startsWith(':');

    if (isDynamicRoute && !!route.snapshot) {
      const paramName = lastRoutePart.split(':')[1];
      path = path.replace(lastRoutePart, route.snapshot.params[paramName]);
      label = route.snapshot.params[paramName];
    }

    const nextUrl = path ? `${url}/${path}` : url;
    const breadcrumb: IBreadCrumb = {
      label: label,
      url: nextUrl,
    };

    const newBreadcrumbs = breadcrumb.label ? [...breadcrumbs, breadcrumb] : [...breadcrumbs];
    if (route.firstChild) {
      return this.buildBreadCrumb(route.firstChild, nextUrl, newBreadcrumbs);
    }
    return newBreadcrumbs;
  }

  previousPage(url: string): void {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.globalService.setVerificationRoute(true);
    this.router.navigate([url]);
  }

  widthWindow(): void {
    if (window.innerWidth < 1024) {
      this.isCollapsed = true;
    } else {
      this.isCollapsed = false;
    }
  }

  collapseMenu(): boolean {
    if (window.innerWidth < 1024) {
      this.isCollapsed = true;
      return true;
    } else {
      return this.isCollapsed = !this.isCollapsed;
    }
  }
}
